import { auditLogsService } from './database';
import { getAuditActor } from './auditActor';

/** Fire-and-forget audit row from the POS. Never throws. */
export function writeClientAudit(input: {
  action: string;
  entityType: string;
  entityId?: string;
  summary: string;
  details?: Record<string, unknown>;
}): void {
  const actor = getAuditActor();
  auditLogsService
    .add({
      timestamp: Date.now(),
      actorId: actor?.id,
      actorName: actor?.name,
      actorRole: actor?.role,
      action: input.action,
      entityType: input.entityType,
      entityId: input.entityId,
      details: { ...(input.details ?? {}), summary: input.summary },
    })
    .catch((err) => console.error('Audit log failed', err));
}
